import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0335',
    ecrans: ['00-2'],
    params: [
        'id',
        'bpacleint',
        'bqecleint',
        'vaebvltyplim'
    ]
});
